import React from "react";
import { Swiper, Image as AmImage } from "antd-mobile";
import { HeartOutline } from "antd-mobile-icons";
import { getAppDeepLinkUrlHashId } from "@/utils/url";
import { jumpProductToApp } from "@/utils/openApp";
import { useTrack } from "@/hooks/useTrack";
import { TProductInfo } from "@/typings";
import { TrackingVisitSource, TrackingZoneName } from "@/shared";
import ProductPictureSkeleton from "./skeleton";
import { TrackingPoints } from "../../points";
import "./index.scss";

const classPrefix = "yfm-product-detail-picture";

interface ProductImage {
  image_url: string;
}

interface ProductPictureProps {
  hashId: string;
  productInfo: TProductInfo | null;
  images: ProductImage[];
}

const ProductPicture: React.FC<ProductPictureProps> = ({
  hashId,
  productInfo,
  images,
}) => {
  const { tracking } = useTrack();

  const handleFavorites = () => {
    tracking({
      ...TrackingPoints.Favorite,
      product_id: productInfo?.product_id,
    });
    const appParams = {
      visit_source: TrackingVisitSource.ProductDetails,
      zone_name: TrackingZoneName.ProductDetails,
      api_params: "",
    };
    jumpProductToApp(hashId, appParams, getAppDeepLinkUrlHashId(hashId));
  };

  return (
    <div className={classPrefix}>
      {images.length > 0 ? (
        <Swiper
          autoplay
          loop
          indicator={(total, current) => (
            <div className={`${classPrefix}__indicator`}>
              {current + 1} / {total}
            </div>
          )}
        >
          {images.map((image, index) => (
            <Swiper.Item key={index}>
              <AmImage
                className={`${classPrefix}__image`}
                draggable={false}
                fit="cover"
                src={image.image_url}
                alt=""
              />
            </Swiper.Item>
          ))}
        </Swiper>
      ) : (
        <ProductPictureSkeleton />
      )}
      <div className={`${classPrefix}__fav`} onClick={handleFavorites}>
        <HeartOutline />
      </div>
    </div>
  );
};

export default ProductPicture;
